import { render } from "./AssetDetails.vue?vue&type=template&id=3d8ba291&scoped=true"
import script from "./AssetDetails.vue?vue&type=script&lang=js"
export * from "./AssetDetails.vue?vue&type=script&lang=js"

import "./AssetDetails.vue?vue&type=style&index=0&id=3d8ba291&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3d8ba291"]])

export default __exports__